(function () {
  if (typeof IntersectionObserver === 'undefined') return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    },
    { threshold: 0.16, rootMargin: '0px 0px -48px 0px' }
  );
  document.querySelectorAll('.sasage-reveal').forEach(function (el) {
    io.observe(el);
  });
})();
